import { ArrowUpRight, Instagram } from "lucide-react";
import { BRAND, waLink } from "@/lib/brand";

export const FooterCTA = () => {
  return (
    <section
      id="contato"
      data-testid="footer-cta-section"
      className="relative bg-[#050505] border-t border-white/5"
    >
      {/* Big CTA block */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-36">
        <div className="border-t border-white/10 pt-12">
          <p className="text-[11px] uppercase tracking-[0.32em] text-[#facc15] font-bold">
            Solicite Seu Orçamento
          </p>
          <h2 className="mt-6 font-display text-5xl sm:text-7xl lg:text-[120px] xl:text-[140px] leading-[0.9] tracking-tighter text-white">
            Vamos transformar
            <br />
            seu <span className="italic text-[#facc15]">projeto</span>.
          </h2>

          <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <p className="lg:col-span-6 text-zinc-400 text-base lg:text-lg leading-relaxed max-w-2xl">
              Transforme seu projeto com esquadrias modernas, resistentes e
              com acabamento premium. Nossa equipe está pronta para atender
              você.
            </p>
            <div className="lg:col-span-6 flex flex-col sm:flex-row gap-4 lg:justify-end">
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-btn"
                className="group inline-flex items-center justify-between gap-4 px-7 py-5 bg-[#facc15] text-black font-bold uppercase text-[11px] tracking-[0.28em] hover:bg-white transition-colors"
              >
                {BRAND.whatsapp_display}
                <ArrowUpRight
                  size={18}
                  strokeWidth={2}
                  className="group-hover:rotate-45 transition-transform"
                />
              </a>
              <a
                href={BRAND.instagram_url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-btn"
                className="inline-flex items-center justify-between gap-4 px-7 py-5 border border-white/20 text-white font-bold uppercase text-[11px] tracking-[0.28em] hover:bg-white hover:text-black transition-colors"
              >
                <Instagram size={18} strokeWidth={1.5} />
                {BRAND.instagram_handle}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer
        data-testid="site-footer"
        className="border-t border-white/10 bg-black"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5 flex items-center gap-4">
            <img
              src={BRAND.logo_url}
              alt="ATL Esquadrias"
              className="h-14 w-14 object-contain"
            />
            <div>
              <p className="font-display text-xl text-white leading-tight">
                ATL Esquadrias
              </p>
              <p className="text-[11px] uppercase tracking-[0.28em] text-[#facc15] mt-1">
                {BRAND.tagline}
              </p>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.28em] text-zinc-500">
              Contato
            </p>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="block mt-3 font-display text-lg text-white hover:text-[#facc15]"
              data-testid="footer-contact-whatsapp"
            >
              WhatsApp · {BRAND.whatsapp_display}
            </a>
            <a
              href={BRAND.instagram_url}
              target="_blank"
              rel="noopener noreferrer"
              className="block mt-1 text-sm text-zinc-400 hover:text-[#facc15]"
              data-testid="footer-contact-instagram"
            >
              Instagram {BRAND.instagram_handle}
            </a>
          </div>

          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.28em] text-zinc-500">
              Atendimento
            </p>
            <p className="mt-3 text-sm text-zinc-300 leading-relaxed">
              Florianópolis e toda a região da Grande Floripa.
              <br />
              Residencial, comercial e construtoras.
            </p>
          </div>
        </div>
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[11px] uppercase tracking-[0.22em] text-zinc-500">
            <span>
              © {new Date().getFullYear()} ATL Esquadrias — Soluções em
              Alumínio e Vidro
            </span>
            <span>Qualidade em cada detalhe · Confiança em cada projeto</span>
          </div>
        </div>
      </footer>
    </section>
  );
};
